import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { ErrorPage_404 } from 'modules/common/routes/ErrorPage';
import { RouteTabs, routePathMap } from '../common/routes';
import { useDefaultRoutes } from './useDefaultRoutes';
import { SidePanel } from './SidePanel';
import SubstituteUserBanner from './SubstituteUserBanner';

export const RootPage: React.FC = () => {
  const noteSelectionForm = useForm<Record<string, boolean>>({});
  const defaultRoutes = useDefaultRoutes();

  return (
    <FormProvider {...noteSelectionForm}>
      <SubstituteUserBanner />
      <RouteTabs routes={defaultRoutes}>
        <Redirect exact from="/" to={routePathMap.notes} />
        <Route path="/404" component={ErrorPage_404} />
        <Redirect to="/404" />
      </RouteTabs>
      <SidePanel />
    </FormProvider>
  );
};
